import RegulatoryCompliance from '../components/AMI/RegulatoryComplianceSection';
import MeteringEcosystem from '../components/AMI/MeteringEcosystem';
import AMIMeteringSection from '../components/AMI/RedefiningSection';
import ProductHeroSection from '../components/Common/ProductHeroSection';

const AMI = () => {

  const heroButtons = [
    {
      label: 'Explore AMI Solutions',
      className: 'btn-secondary',
      onClick: () => console.log('Explore clicked')
    },
    {
      label: 'Learn More',
      className: 'btn-outline',
      onClick: () => console.log('Learn More clicked')
    },
  ];

  return (
    <div>
      <ProductHeroSection
      backgroundImage='/assets/AMI/hero-bg.svg'
      contentImage='/assets/AMI/hero.svg'
      title="Enabling intelligent, secure, and connected metering for the digital era"
      description="Avexa’s Advanced Metering Infrastructure (AMI) solutions empower utilities and enterprises with real-time visibility, automated data collection, and actionable insights."
      imagePosition="right"
      buttons={heroButtons}
    />

      <AMIMeteringSection
      image='/assets/AMI/2section.svg'
      title="Redefining Metering with AMI"
      subtitle="An integrated ecosystem enabling two-way communication and real-time intelligence"
      description1="Advanced Metering Infrastructure (AMI) is an integrated system of smart meters, communication networks, and data management platforms that enables two-way communication between service providers and consumers."
      description2="By automating meter data collection and enabling real-time information exchange, AMI eliminates manual processes, improves transparency, and supports data-driven operations across utility and enterprise environments."
    />

    <MeteringEcosystem />

      <RegulatoryCompliance />
      <div className="h-8 md:h-12 lg:h-16 bg-white"></div>

    </div>
  );
};

export default AMI;